import React from 'react';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Menusecundario from 'components/menu-secundario/menu-secundario';

function Header() {
  return (
    <Container>
      <Row>
        <h2>Configurações</h2>
      </Row>
      <Row>
        <Menusecundario />
      </Row>
    </Container>
  );
}

export default Header;
